import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateDraftField } from "src/redux/actions/experiences/storyboardSettings";
import { selectStoryboardDraft } from "src/redux/selectors/experiences/storyboardSettings";
import { StoryboardResponse } from "src/types/experiences/storyboardSettings/storyboard";

export const useDraft = () => {
  const dispatch = useDispatch();
  const draft = useSelector(selectStoryboardDraft);

  const setField = useCallback(
    <K extends keyof StoryboardResponse>(key: K, value: StoryboardResponse[K]) => {
      dispatch(updateDraftField({ key, value: value as unknown }));
    },
    [dispatch],
  );

  return { draft, setField };
};
